import React from "react";
import Xcountries from "./Components/XCountries";
import XStopWatch from "./Components/XStopWatch";
import XDisplayName from "./Components/XDisplayName";
import XCounter from "./Components/XCounter";
import XCalculator from "./Components/XCalculator";
import XCountrySearch from "./Components/XCountrySearch";

const App = () => {
  return (
    <>
      {/* <Xcountries/> */}
      {/* <XStopWatch/> */}
      {/* <XDisplayName/> */}
      {/* <XCounter/> */}
      {/* <XCalculator/> */}
      <XCountrySearch/>
    </>
  );
}

export default App;